import { defineStore } from 'pinia'

export const useHeaderStore = defineStore('header', {
    state: () => ({
        emailChangeObserver: ''
        , verifiedChangeObserver: false
        , initialized: false
    }),
    actions: {
        updateEmail(email) {
            this.emailChangeObserver = email
            this.initialized = true
        },
        updateVerified(status) {
            this.verifiedChangeObserver = status
        }
    }
})